(function () {

  const script = document.currentScript;
  const sectionId = script?.dataset.psfId;

  if (!sectionId) return;

  const section = document.getElementById(sectionId);

  if (!section) return;

  const cards =
    section.querySelectorAll(
      '[data-psf-card]'
    );


  const mobileQuery =
    window.matchMedia(
      '(max-width: 749px)'
    );


  /* ========================================================
     SET DESKTOP / MOBILE STATE
  ======================================================== */

  function syncState() {

    cards.forEach(function (card) {

      const button =
        card.querySelector(
          '[data-psf-toggle]'
        );


      if (!button) return;


      if (!mobileQuery.matches) {

        card.classList.add(
          'is-open'
        );

        button.setAttribute(
          'aria-expanded',
          'true'
        );

        button.setAttribute(
          'tabindex',
          '-1'
        );

      } else {

        card.classList.remove(
          'is-open'
        );

        button.setAttribute(
          'aria-expanded',
          'false'
        );

        button.removeAttribute(
          'tabindex'
        );

      }

    });

  }


  /* ========================================================
     ACCORDION
  ======================================================== */

  section.addEventListener(
    'click',
    function (event) {

      if (!mobileQuery.matches) {
        return;
      }


      const button =
        event.target.closest(
          '[data-psf-toggle]'
        );


      if (!button) {
        return;
      }


      const card =
        button.closest(
          '[data-psf-card]'
        );


      if (!card) {
        return;
      }


      const willOpen =
        !card.classList.contains(
          'is-open'
        );


      /* Close other cards */

cards.forEach(function (otherCard) {

  if (
    otherCard === card ||
    !otherCard.classList.contains('is-open')
  ) {
    return;
  }

        otherCard.classList.remove(
          'is-open'
        );


        const otherButton =
          otherCard.querySelector(
            '[data-psf-toggle]'
          );


        if (otherButton) {

          otherButton.setAttribute(
            'aria-expanded',
            'false'
          );

        }

      });


      /* Current card */

      card.classList.toggle(
        'is-open',
        willOpen
      );


      button.setAttribute(
        'aria-expanded',
        willOpen
          ? 'true'
          : 'false'
      );

    }
  );


  /* ========================================================
     RESPONSIVE STATE
  ======================================================== */

  syncState();


  if (
    typeof mobileQuery.addEventListener
    === 'function'
  ) {

    mobileQuery.addEventListener(
      'change',
      syncState
    );

  } else {

    mobileQuery.addListener(
      syncState
    );

  }

})();